document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle: swaps the nav into a simple dropdown under the header.
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('.ph-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      nav.style.display = isOpen ? 'flex' : 'none';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = 'var(--ph-cream)';
      nav.style.padding = '16px 24px';
      nav.style.borderBottom = '1px solid var(--ph-line)';
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }
});
